<app-general-search-input
  [title]="title | translate"
  [expanded]="form.get('drinkType')?.value?.length > 0"
>
  <ng-template>
    <form class="easy-form" [formGroup]="form">
      <mat-form-field>
        <app-easy-select-expandable
          label=""
          formControlName="drinkType"
          [options]="drinkTypes"
          [labelAttribute]="'name'"
          [groupLabelAttribute]="'groupName'"
          [groupOptionsAttribute]="'options'"
          [valueAttribute]="'value'"
          [multiple]="true"
          (ngModelChange)="valueChanged($event)"
        ></app-easy-select-expandable>
      </mat-form-field>
    </form>
  </ng-template>
</app-general-search-input>
